<template>
	<div class="main">
		<div class="desc" v-html="detail.details"></div>
		<div class="btn-group">
			<button class="submit" @click="next">开始评测</button>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				id:"",
				detail:{}
			}
		},
		created(){
			this.id = this.$route.query.id;
			this.queryIntroduceDetails()
		},
		methods:{
			next(){
				this.$router.push({path:"/refined/assess/verify"});
			},
			queryIntroduceDetails(){
				this.$request({
					url:this.$api.refined.queryIntroduceDetails,
					data:{introduceId:this.id}
				}).then((res)=>{
					this.detail = res.data.result;
				})
			}
		}
	}
</script>

<style scoped>
	.main{
		background:url(../../../assets/yijianceping.jpg);
		width: 100%;
		height: 574px;
		position: relative;
	}
	
	.desc{
		width:660px;
		height: 240px;
		overflow: auto;
		position: absolute;
		top:190px;
		left:70px;
		scrollbar-width: none;
		scrollbar-color: transparent transparent;
	}
	
	.btn-group{
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		position: absolute;
		bottom:30px;
		display:flex;
		justify-content: center;
	}
	
	.btn-group .submit{
		width: 149px;
		height: 54px;
		color: #1e6ee9;
		background-color: #ffffff;
		border: none;
		border-radius: 12px;
		font-size: 16px;
		font-weight: bold;
	}
</style>


// WEBPACK FOOTER //
// src/pages/refined/assess/index.vue